import { REQUEST } from '../request';

export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SEND_OFFER_SUCCESS = 'SEND_OFFER_SUCCESS';
export const SEND_OFFER_FAILED = 'SEND_OFFER_FAILED';

export const Types = {
  CLOSE_MODAL,
  SEND_OFFER_SUCCESS,
  SEND_OFFER_FAILED,
};

export const initialState = {
  isFetching: false,
  isModalOpen: false,
};

const offer = (state = initialState, action) => {
  if (!action) return state;

  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isFetching:
          (action.payload && /OFFER/.test(action.payload.action)) ||
          state.isFetching,
        isModalOpen: false,
      };
    case SEND_OFFER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isModalOpen: true,
      };
    case SEND_OFFER_FAILED:
      return {
        ...state,
        isFetching: false,
        isModalOpen: false,
      };
    case CLOSE_MODAL:
      return {
        ...state,
        isModalOpen: false,
      };

    default:
      return state;
  }
};

export const closeModal = () => ({
  type: Types.CLOSE_MODAL,
  payload: {},
});

export const Actions = {
  closeModal,
};

export default offer;
